export const product = `
  id
  tags
  title
  handle
  description
  productType
  vendor
  collections(first: 1) {
    edges {
      node {
        title
      }
    }
  }
  options {
    id
    name
    optionValues {
      name
    }
  }
  availableForSale
  priceRange {
    minVariantPrice {
      amount
    }
    maxVariantPrice {
      amount
    }
  }
  compareAtPriceRange {
    minVariantPrice {
      amount
    }
    maxVariantPrice {
      amount
    }
  }
  images(first: 25) {
    edges {
      node {
        src: url
        altText
      }
    }
  }
  media(first: 50) {
    edges {
      cursor
      node {
        alt
        mediaContentType
        previewImage {
          altText
          src: url
        }
        ... on ExternalVideo {
          id
          embedUrl
          host
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
  variants(first: 50) {
    edges {
      node {
        id
        sku
        title
        price {
          amount
        }
        compareAtPrice {
          amount
        }
        unitPrice {
          amount
        }
        unitPriceMeasurement {
          referenceUnit
          referenceValue
          quantityValue
          quantityUnit
          measuredType
        }
        sellingPlanAllocations(first: 10) {
          edges {
            node {
              sellingPlan {
                id
                name
                options {
                  name
                  value
                }
              }
            }
          }
        }
        availableForSale
        quantityAvailable
        image {
          src: url
          altText
        }
        sizeSubtitle: metafield(namespace: "general", key: "size_subtitle") {
          key
          value
        }
        isBundleVariant: metafield(namespace: "accentuate", key: "use_in_bundle") {
          key
          value
        }
        shortDescription: metafield(namespace: "general", key: "short_description") {
          key
          value
        }
        sourceGWPCollectionItem: metafield(namespace: "accentuate", key: "use_in_gwp") {
          key
          value
        }
        isGWPVariant: metafield(namespace: "accentuate", key: "is_gwp_variant") {
          key
          value
        }
        bundleBuilderProductIds: metafield(namespace: "bundle_builder", key: "product_ids") {
          key
          value
        }
      }
    }
  }
  metafields(identifiers: [
    { namespace: "accentuate", key: "bundled_products" },
    { namespace: "accentuate", key: "custom_message" },
    { namespace: "accentuate", key: "shipping_message" },
    { namespace: "accentuate", key: "video" },
    { namespace: "accentuate", key: "video_thumb" },
    { namespace: "banner", key: "image_desktop" },
    { namespace: "banner", key: "image_mobile" },
    { namespace: "banner", key: "text" },
    { namespace: "banner", key: "text_color" },
    { namespace: "banner", key: "content" },
    { namespace: "banner", key: "open_chat_instead_of_linking" },
    { namespace: "general", key: "custom_attributes" },
    { namespace: "general", key: "custom_message" },
    { namespace: "general", key: "disclaimer" },
    { namespace: "general", key: "hide_shade_buttons" },
    { namespace: "general", key: "hide_shade_range_filter" },
    { namespace: "general", key: "hide_try_shade_on_button" },
    { namespace: "general", key: "icons" },
    { namespace: "general", key: "is_discontinued" },
    { namespace: "general", key: "shipping_delay_text" },
    { namespace: "general", key: "shipping_message" },
    { namespace: "general", key: "short_description" },
    { namespace: "card", key: "description" },
    { namespace: "general", key: "award_images" },
    { namespace: "general", key: "cart_upsell_bundle" },
    { namespace: "cart_promo", key: "promo_text" },
    { namespace: "cart_promo", key: "link" },
    { namespace: "personalized_bundles", key: "description" },
    { namespace: "personalized_bundles", key: "step_titles" },
    { namespace: "personalized_bundles", key: "title" },
    { namespace: "product_bundles", key: "number_of_items" },
    { namespace: "swatch_management", key: "additional_categories" },
    { namespace: "swatch_management", key: "custom_image" },
    { namespace: "swatch_management", key: "custom_hex" },
    { namespace: "yotpo", key: "reviews_average" },
    { namespace: "yotpo", key: "reviews_count" },
  ]) {
    key
    value
    namespace
  }
  shadeDetails: metafield(namespace: "shade_finder_results", key: "shade_details") {
    key
    value
  }
`;

export const microCollection = `
  title,
  handle,
  metafields(identifiers: [
    { namespace: "micro_collection", key: "enable_micro_collection" },
    { namespace: "general", key: "brand" },
    { namespace: "general", key: "short_description" },
    { namespace: "card", key: "description" }
  ]) {
    key
    value
    namespace
  }
`;
